<ion-card (click)="addClicked()" [ngClass]="{'AQA-setItem': isSet, 'AQA-aLaCarteItem': !isSet}"
          class="item-wrapper animated fadeInUps item-card" ng-switch-when="category">

    <div class="img-square center-cropped" style="background: white;" [ngClass]="{'no-img': imgs[index] == null}">

        <div *ngIf="_item.tags.length > 0" class="tag-image-box">
            <div class="tag-images-wrapper">
                <ng-container *ngFor="let tagsImg of _item.tags">
                    <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}"
                         [ngClass]="{'single' : _item.tags.length == 1}">

                </ng-container>
            </div>
        </div>
        <!-- Item tag -->
        <!-- <div *ngIf="item.tags.length > 0" class="tag-image-box" [ngStyle]="{'background-image': 'url(' + getTagsImage(_item) + ')'}"></div> -->
        <div class="item-img-box">
            <!-- <img src="{{imgs[i]}}" (error)="showEmpty(i)" /> -->
            <img src="{{imgs[index]}}"/>
            <!-- <p class="combo-option" *ngIf="_item.minPrice">
                <span>Option</span>
                <ion-icon name="ios-arrow-forward" class="combo-option-icon"></ion-icon>
            </p> -->
            <ion-icon name="md-add" class="combo-option" *ngIf="_item.minPrice"></ion-icon>
            <ion-icon name="md-add" class="no-combo-add-icon" *ngIf="!_item.minPrice"></ion-icon>

        </div>


        <div class="sold-out-box AQA-soldOut" *ngIf="getSoldout()">
            <span>{{"pages.item-grid.soldout" | translate}}</span>
        </div>

        <div class="qty-panel" *ngIf="_quantity > 0 && !isSet && !_item?.variations && !_item?.variations">
            <!-- <ion-button fill="clear" class="btn-qty-remove AQA-minus-button"
                (click)="removeClicked();$event.stopPropagation();"> -->
            <ion-icon (click)="removeClicked();$event.stopPropagation();" name="md-remove"
                      class="btn-qty-remove AQA-minus-button"></ion-icon>
            <!-- </ion-button> -->
            <div class="qtn-with-item">
                <p class="AQA-item-qty">{{_quantity}}</p>
            </div>
            <!-- <ion-button fill="clear" class="btn-qty-add AQA-add-button"> -->
            <ion-icon name="md-add" class="btn-qty-add AQA-add-button"></ion-icon>
            <!-- </ion-button> -->
        </div>
    </div>
    <div class="item-info" [ngClass]="{ isEn : isEn}">

        <div class="item-title">
            {{name}}
        </div>
        <p class="item-desc line-clamp AQA-itemDesc">{{_item.desc}}</p>
        <div class="item-price" *ngIf="!settings?.hideZeroItemPrice || _item.price > 0">
            <span *ngIf="!_item.minPrice"
                  class="itemPrice-text">{{currencySign === '€' ? '' : currencySign}}
                {{_item|itemPrice}}{{currencySign === '€' ? '€' : ''}}
            </span>
            <span *ngIf="_item.minPrice" class="itemPrice-text">{{currencySign === '€' ? '' : currencySign}}{{ _item.minPrice | number : '1.'+ orderManager?.getPrecision()||0 + '-' + orderManager?.getPrecision()||2}}
                {{currencySign === '€' ? '€' : ''}}
                {{"global.up" | translate}} </span>
            <!-- <span>{{orderManager?.store?.currencySign}}{{item.price | number : '1.'+ orderManager?.getPrecision()||0 + '-' + orderManager?.getPrecision()||2}}</span> -->
            <!-- <ion-icon class="icon-next" name="ios-arrow-forward"></ion-icon> -->
        </div>
    </div>
</ion-card>
